import { render, staticRenderFns } from "./zypx.vue?vue&type=template&id=f6971940&scoped=true"
import script from "./zypx.vue?vue&type=script&lang=js"
export * from "./zypx.vue?vue&type=script&lang=js"
import style0 from "./zypx.vue?vue&type=style&index=0&id=f6971940&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f6971940",
  null
  
)

export default component.exports